module.exports = __webpack_public_path__ + "img/expodecor_mosaic0620_beige_cement_tiles.a08d357e.jpg";